import { Box, PageGrid, Grid, Stack, Text } from '@eneco/sparky';
import { SpinnerIcon } from '@eneco/sparky/icons';

const LoadingPage = ({ text }: { text: string }) => {
  return (
    <Box paddingY="10" backgroundColor="backgroundSecondary">
      <PageGrid>
        <Grid.Item gridColumn={{ initial: '1/-1', md: '4/-2', lg: '4/10' }} gridRowStart="1">
          <Box paddingBottom="10">
            <Stack direction={'column'} gap={'1'} alignX={'center'} alignY={'center'}>
              <Text size="BodyL" align={'center'}>
                {text}
              </Text>
              <span>
                <SpinnerIcon size={'large'}></SpinnerIcon>
              </span>
            </Stack>
          </Box>
        </Grid.Item>
      </PageGrid>
    </Box>
  );
};

export default LoadingPage;
